import * as PropTypes from 'prop-types';
export var appointmentType = PropTypes.shape({
    id: PropTypes.number,
    cancelled: PropTypes.string,
    comment: PropTypes.string,
    cancellable: PropTypes.bool,
});
